module.exports = __webpack_public_path__ + "img/img0205.cbe60bee.png";